import React from 'react';
import { Button } from './ui/button';
import { Truck, Factory, Warehouse, PackageCheck, TrendingUp, Wallet, CalendarCheck2, Database, Plug, ArrowRight } from 'lucide-react';
import { useLanguage } from '../lib/LanguageContext';
interface FeatureGridProps {
  onNavigate?: (page: 'home' | 'fitur' | 'kontak') => void;
}
export function FeatureGrid({
  onNavigate
}: FeatureGridProps) {
  const {
    t
  } = useLanguage();
  const icons = [<Truck className="w-5 h-5" data-id="element-90" />, <Factory className="w-5 h-5" data-id="element-91" />, <Warehouse className="w-5 h-5" data-id="element-92" />, <PackageCheck className="w-5 h-5" data-id="element-93" />, <TrendingUp className="w-5 h-5" data-id="element-94" />, <Wallet className="w-5 h-5" data-id="element-95" />, <CalendarCheck2 className="w-5 h-5" data-id="element-96" />, <Database className="w-5 h-5" data-id="element-97" />, <Plug className="w-5 h-5" data-id="element-98" />];
  return <section id="features" className="py-16 md:py-24 lg:py-40 bg-white" data-id="element-99">
      <div className="container mx-auto px-4 sm:px-6 md:px-8" data-id="element-100">
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-24" data-id="element-101">
          <p className="text-forest-500 font-semibold text-xs uppercase tracking-[0.2em] mb-6" data-id="element-102">
            {t.features.label}
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-forest-900 tracking-tight mb-6" data-id="element-103">
            {t.features.headline}
          </h2>
          <p className="text-xl text-forest-600 font-light leading-relaxed" data-id="element-104">
            {t.features.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-105">
          {t.features.items.map((feature, idx) => <div key={idx} className="group bg-white rounded-2xl p-6 border border-forest-100 shadow-sm hover:shadow-md hover:border-forest-200 transition-all duration-300" data-id="element-106">
              <div className="w-12 h-12 bg-forest-50 rounded-xl flex items-center justify-center mb-5 text-brand-green group-hover:bg-brand-green group-hover:text-white transition-all duration-300" data-id="element-107">
                {icons[idx] ?? icons[0]}
              </div>
              <h3 className="font-semibold text-forest-900 text-lg mb-2" data-id="element-108">
                {feature.name}
              </h3>
              <p className="text-sm text-forest-600 leading-relaxed" data-id="element-109">
                {feature.desc}
              </p>
            </div>)}
        </div>

        <div className="text-center mt-12 md:mt-24" data-id="element-110">
          <Button onClick={() => onNavigate?.('fitur')} className="bg-brand-green hover:bg-forest-600 text-white font-semibold h-12 px-8 rounded-lg transition-all shadow-lg shadow-forest-200 hover:shadow-xl hover:-translate-y-0.5 inline-flex items-center gap-2" data-id="element-111">
            {t.features.cta}
          </Button>
        </div>
      </div>
    </section>;
}